import { IDocumentVersionEditItem, DocumentVersionEditItem } from "./documentVersionEditItem";

export interface IDocumentVersionEdit {
    item: IDocumentVersionEditItem;
}

export class DocumentVersionEdit implements IDocumentVersionEdit {
    item: DocumentVersionEditItem;

    constructor();
    constructor(obj: IDocumentVersionEdit);
    constructor(obj?: any) {
        this.item = new DocumentVersionEditItem(obj ? obj.item : null);
    }
}